import { useMutation } from "react-query";
import api from "../../client";
import { Institution, UpdateInstitutionPayload } from "../../types/institution";

const patchData = async (
  id: string | undefined,
  payload: UpdateInstitutionPayload,
): Promise<Institution> => {
  const { data } = await api.patch(`/institutions/${id}`, payload);

  return data;
};

export const useUpdateInstitution = (id: string | undefined) => {
  return useMutation((payload: UpdateInstitutionPayload) => {
    return patchData(id, payload);
  });
};
